export const followUpdate = 'Follow-up Date'
export const profilePicture = 'Profile Picture'
export const signatureText = 'Signature of Doctor with Reg No'
export const usercreation = 'UserCreation'
export const locationcreation = 'Create Location '
export const editlocation = 'Edit Location'
export const OPRegistration = 'OP Registration'
export const getallRegType = 'getallRegType'
export const RegistrationType = 'Registration Type'
export const imageValidationRegex = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i
export const REGISTRATION_TYPES: Record<
  string,
  { text: string; title: string }
> = {
  fr: { text: 'Full', title: 'Full Registration' },
  qr: { text: 'Quick', title: 'Quick Registration' },
  er: { text: 'ER', title: 'Emergency' },
  pmc: { text: 'Pharmacy', title: 'Pharmacy' },
  lab: { text: 'Lab', title: 'Laboratory' },
  dgs: { text: 'Diagnostics', title: 'Diagnostics' },
  camp: { text: 'Campaign', title: 'Campaign' },
  membership: { text: 'MemberShip', title: 'MemberShip' },
  membershipPrimary: { text: 'MemberShip', title: 'MemberShip' },
  ABMembershipQuick: { text: 'AB MemberShip', title: 'AB MemberShip Full' },
  ABMembershipFull: { text: 'AB MemberShip', title: 'AB MemberShip Full' },
  package: { text: 'Package', title: 'Package' },
}
export const unpaid = 'unpaid'
export const roleErrorMessage = 'No Role Assigned To Export Data'
export const validFormatTypes = {
  application: 'application/pdf',
  excel: 'application/vnd.ms-excel',
  xml: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xlms: 'application/wps-office.xlsx',
}
export const extensionsType = ['pdf', 'xls', 'xlsx']
export const pdfErrors = {
  allowedError: 'Only PDF or Excel files (.pdf, .xls, .xlsx) are allowed',
  validPdf: 'Please select a valid PDF or Excel file before submitting',
}
export const registrationType = 'registrationType'
export const uploadPdf =
  'Upload a PDF or Excel file (.pdf, .xls, .xlsx) with bulk registration data.'
export const registrationTypeKey = 'Registration Type'
export const resetKey = 'Reset'
export const bulkRegistrationKey = 'Bulk Registration'
export const bulkRegistrationValue = 'bulkRegistration'
export const success = 'success'
export const viewer = 'viewer'
export const opCaseSheetPDFViewer = 'OpCaseSheetPDFViewer'
export const thopIdentifier = 'thop-identifier'
export const dietString = {
  veg: 'veg',
  mixed: 'mixed',
  adequate: 'adequate',
  inadequate: 'inadequate',
  regular: 'regular',
  irregular: 'irregular',
}
export const illnessHistory = {
  Pallor: 'Pallor',
  Icterus: 'Icterus',
  Cyanosis: 'Cyanosis',
  Clubbing: 'Clubbing',
  Edema: 'Edema',
  Lymphadenopathy: 'Lymphadenopathy',
  yes: 'yes',
}

// OP Case Sheet Labels
export const opCaseSheetLabels = {
  patientUHID: 'Patient UHID',
  name: 'Name',
  gender: 'Gender',
  age: 'Age',
  date: 'Date',
  department: 'Department',
  doctorName: 'Doctor Name',
  doctorPrefix: 'Dr.',
  outPatientCaseSheet: 'OUT PATIENT CASE SHEET',
  wongBakerPainScore: 'Wong-Baker Pain Score',
  historyExamination: 'History & Examination',
  chiefComplaints: 'Chief Complaints & Duration',
  historyPresentingIllness: 'History of Presenting Illness',
  pastHistory: 'Past History',
  personalHistory: 'Personal History',
  diet: 'Diet:',
  sleep: 'Sleep:',
  bowelBladder: 'Bowel & Bladder:',
  veg: 'Veg',
  mixed: 'Mixed',
  adequate: 'Adequate',
  inadequate: 'Inadequate',
  regular: 'Regular',
  irregular: 'Irregular',
  smokingHistory: 'Smoking History',
  alcoholHistory: 'Alcohol History',
  drugAllergies: 'History of Drug Allergies',
  otherRelevantHistory: 'Other Relevant Habitual History',
  familyHistory: 'Family History',
  obstetricHistory: 'Obstetric History',
  previousSurgeries: 'History of Previous Surgeries',
  generalPhysicalExam: 'General Physical Examination',
  heightCM: 'Height (CM)',
  weightKG: 'Weight (KG)',
  bmi: 'BMI',
  vitals: 'Vitals',
  pulse: 'Pulse',
  bloodPressure: 'Blood Pressure (mm Hg)',
  temperature: 'Temperature (F)',
  posture: 'Posture',
  respiratoryRate: 'Respiratory Rate',
  spo2: 'SpO2 (%)',
  systemicExamination: 'Systemic Examination',
  localExamination: 'Local Examination',
  cardiovascularSystem: 'Cardiovascular System',
  respiratorySystem: 'Respiratory System',
  nervousSystem: 'Nervous System',
  perAbdomen: 'P/A (Per Abdomen)',
  diagnosis: 'Diagnosis',
  provisionalDiagnosis: 'Provisional Diagnosis',
  finalDiagnosis: 'Final Diagnosis',
  differentialDiagnosis: 'Differential Diagnosis',
  investigationsDiagnostics: 'Investigations / Diagnostics',
  treatmentPlan: 'Treatment Plan',
  defaultValue: '-',
  notAvailable: 'NA',
}

export const painScoreLabels = {
  noHurt: 'No Hurt',
  hurtsLittleBit: 'Hurts Little Bit',
  hurtsLittleMore: 'Hurts Little More',
  hurtsEvenMore: 'Hurts Even More',
  hurtsWholeLot: 'Hurts Whole Lot',
  hurtsWorst: 'Hurts Worst',
}

export const pdfViewerLabels = {
  downloadOpCaseSheet: 'Download OP Case Sheet',
  opCaseSheetPrefix: 'OpCaseSheet_',
  patient: 'patient',
  pdfExtension: '.pdf',
  errorGeneratingPDF: 'Error generating PDF',
}
